/*
 * @Date: 2020-08-20 11:13:13
 * @Author: MX
 * @LastEditTime: 2020-10-30 10:00:39
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/index.scss'
import '@/assets/style/element-variables.scss'
import * as Api from '@/api'
import i18n from "./utils/i18n"

Vue.config.productionTip = false
Vue.prototype.$API = Api

new Vue({
  i18n,
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
